import React from "react";
import styled from "styled-components";
import { ButtonRound } from "components/generic/kit";

export default ({ insider, consultation }) => (
  <Wrap>
    <Container>
      <div>
        <div className="fw6 f3">
          {consultation ? "15 Minute Consultation ($10)" : insider.title}
        </div>
        <div className="f5 gray">
          {consultation ? "The Lobby Team" : insider.company.name}
        </div>
      </div>
      <div className="ml-auto flex items-center">
        <div className="f4 fw6 mr3">
          ${consultation ? "10" : insider.call_price.current}
        </div>
        <a href="#objectives">
          <ButtonRound>Schedule a call</ButtonRound>
        </a>
      </div>
    </Container>
  </Wrap>
);

const Container = styled.div`
  max-width: 1140px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
`;

const Wrap = styled.div`
  padding: 1rem 0;
  background-color: #fff;
  border-top: 7px solid #f76367;
`;



// WEBPACK FOOTER //
// ./src/components/common/candidate/ScheduleCall/components/FixedHeader/index.js